import { axios } from '@Root/API'

export const get = (contactId, params) => {
	return axios.get(`contacts/${contactId}/module-instance`, {
		params,
	})
}
